export enum ActAsTypes {
  Admin = "admin",
  TeamManager = "team-manager",
}
